import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import NotFound from '../../components/illustrations/NotFound';
import NavBar from '../../components/NavBar';
import { H2Text, H3Text } from '../../components/UI/Text';
import { redirectExploreProperties } from '../../shared/helpers/redirect';
import {
  IllustrationContainer,
  StyledBodyContainer,
  StyledButton,
  StyledContainer,
} from './VisitRequestWasSent.style';

const VisitRequestWasSent = (): JSX.Element | null => {
  const { t } = useTranslation(['requestwassent']);
  const { visitId, locale } = useParams();
  const onClickExploreProperties = () => {
    visitId && locale && redirectExploreProperties(visitId, locale);
  };

  return (
    <StyledContainer>
      <NavBar />
      <StyledBodyContainer>
        <H2Text
          alignSelf="center"
          padding="0"
          smPadding="0 5rem"
          mdPadding="0 13rem"
          lgPadding="0 21.5rem"
        >
          {t('requestwassent:firstHeader')}
        </H2Text>
        <H3Text
          fontWeight={'lighter'}
          textAlign="center"
          padding="0"
          smPadding="0 5rem"
          mdPadding="0 14rem"
          lgPadding="0 21rem"
        >
          {t('requestwassent:secondHeader')}
        </H3Text>
        <IllustrationContainer>
          <NotFound />
        </IllustrationContainer>
        <StyledButton onClick={onClickExploreProperties}>
          {t('requestwassent:exploreProperties')}
        </StyledButton>
      </StyledBodyContainer>
    </StyledContainer>
  );
};
export default VisitRequestWasSent;
